import React, {
  FC, useMemo, useState,
} from 'react';
import _ from 'lodash';
import { Badge } from 'reactstrap';

import history from 'app/routes/history';
import ModalConfirm from 'app/components/general/ModalConfirm';
import Table from 'app/components/general/TableNew';
import Button from 'app/components/general/Button';
import PlusIcon from 'app/images/icons/plus.svg';

import * as connectionRunSelectors from 'app/ducks/connectionRuns/selectors';

// import ConnectIcon from 'app/images/icons/linked.svg';

interface IProps {
  actions: any;
  connectionRunsById: any[];
  connectionRunIds: string[];
  teamId?: string;
  headerTitle?: string;
  connectionId?: string;
  appReady?: boolean;
  isLoading: boolean;
  manual?: boolean;
  saveFilters?: boolean;
  initialFilterConfig?: any;
  persistentFilterConfig?: any;
  pagination?: any;
  connections?: any;
}

const ConnectionRunsTable: FC<IProps> = (props: IProps = {
  manual: true,
  actions: undefined,
  connectionRunsById: undefined,
  connectionRunIds: undefined,
  initialFilterConfig: {},
  persistentFilterConfig: {},
  isLoading: false,
  pagination: undefined,
}) => {
  const [createModalOpen, setCreateModalOpen] = useState(false);


  const fetchDataFromApi = ({
    sort, filter, pageNumber, pageSize,
  }): void => {
    if (
      props.appReady
      && !props.isLoading
      && (pageNumber !== props.pagination.page.number
        || (!_.isEmpty(sort) && sort !== props.pagination.sort)
        || filter !== props.pagination.filter)
    ) {
      props.actions.getAllConnectionRuns({
        page: {
          size: pageSize,
          number: pageNumber,
        },
        sort,
        filter,
      });
    }
  };

  const handeCloseCreateModal = (e): void => {
    e.preventDefault();
    setCreateModalOpen(false);
  };

  const handleOpenCreateModal = (e): void => {
    e.preventDefault();
    setCreateModalOpen(true);
  };

  const renderCreateModal = (): React.ReactNode => (
    <ModalConfirm
      title="Run Connection"
      description="Are you sure you want to run this connection?"
      buttonText="Run"
      isOpen={createModalOpen}
      isLoading={props.isLoading}
      handleSubmit={() => {
        props.actions.createConnectionRun({
          name: `${props.connections.currentConnection.name} - Run`,
          connection: {
            id: props.connections.currentConnection.id,
          },
          competition: {
            id: props.connections.currentConnection.competition.id,
          },
          organisation: {
            id: props.connections.currentConnection.organisation.id,
          },
        });
      }}
      handleCancel={handeCloseCreateModal}
    />
  );

  const handleClick = (id: string): void => {
    props.actions.selectConnectionRun(id);
    history.push(
      `/connections/${props.connectionId}/runs/${id}`,
    );
  };

  const data = useMemo(() => {
    if (_.isEmpty(props.connectionRunsById) || props.connectionRunIds === undefined) {
      return [];
    }
    const connectionRunRows = _.reduce(
      props.connectionRunIds,
      (acc, id) => {
        if (!_.isEmpty(props.connectionRunsById[id])) {
          acc.push(
            connectionRunSelectors.getConnectionRunSummary(
              props.connectionRunsById[id],
            ),
          );
        }
        return acc;
      },
      [],
    );

    return connectionRunRows;
  }, [props.connectionRunsById, props.connectionRunIds]);

  const columns = useMemo(() => [
    {
      Header: 'Name',
      accessor: 'name',
      className: 'col',
      headerClassName: 'col',
    },
    {
      Header: 'Run Time',
      sortable: false,
      className: 'col',
      headerClassName: 'col',
      accessor: 'createdAt',
    },
    {
      Header: 'Status',
      accessor: 'status',
      className: 'col',
      headerClassName: 'col',
      Cell: (cellProps) => _.map(cellProps.value, (tag, key) => (
        <Badge className="extra-padding" key={key} color={tag.colour}>
          {tag.text}
        </Badge>
      )),
    },
  ], []);

  const counterText = props.pagination.meta.totalCount === 1 ? '1 connection run' : `${props.pagination.meta.totalCount || 0} connection runs`;

  return (
    <div>
      {renderCreateModal()}
      <Table
        data={data}
        columns={columns}
        isLoading={props.isLoading}
        // aggressiveLoader
        headerTitle={props.headerTitle}
        objectTitle="connection run"
        filterTitle="Connection Runs Data"
        counterText={counterText}
        handleClick={handleClick}
        filterable={false}
        saveFilters={props.saveFilters}
        manual={props.manual}
        fetchDataFromApi={fetchDataFromApi}
        // filterOptions={filterOptions}
        filterConfig={props.initialFilterConfig}
        persistentFilterConfig={props.persistentFilterConfig}
        pagination={props.pagination}
        showPagination
      >
        {/* <Button
          onClick={handleOpenCreateModal}
          btnIcon={PlusIcon}
          className="btn-thinner btn-2"
        >
          Run Connection
        </Button> */}
      </Table>
    </div>
  );
};

export default ConnectionRunsTable;
